import { personalDataRequest } from '@/api/requests/personal-data';
import { upgradeCookieRequest } from '@/api/requests/upgrade-cookie';
import { asyncSingleton } from '@/_utils/auth-v3/async-singleton';

export class ValidateTokenError extends Error {
  constructor(public message: string, public code?: number) {
    super(message);
  }
}

const validateTokenRaw = async (accessToken: string) => {
  const {
    code: upgradeCookieCode,
    error: upgradeCookieError,
    errorText: upgradeCookieErrorText,
  } = await upgradeCookieRequest({
    token: accessToken,
    middlewaresAreDisabled: true,
  });

  if (upgradeCookieError) {
    throw new ValidateTokenError(upgradeCookieErrorText, upgradeCookieCode);
  }

  const {
    code: personalDataCode,
    error: personalDataError,
    errorText: personalDataErrorText,
  } = await personalDataRequest({
    middlewaresAreDisabled: true,
  });

  if (personalDataError) {
    throw new ValidateTokenError(personalDataErrorText, personalDataCode);
  }

  return true;
};

export const validateToken = (accessToken: string) =>
  asyncSingleton('validationToken', () => validateTokenRaw(accessToken));
